import * as React from 'react';

import { Badge } from '@ui/components/base/badge';
import { Button, type ButtonProps, ButtonVariant } from '@ui/components/base/button';
import { CollapsibleChevron } from '@ui/components/collapses/collapsibleChevron';
import { FilterIcon } from '@ui/components/icons';

interface FilterTriggerButtonProps extends Omit<ButtonProps, 'variant' | 'children'> {
  label: string;
  activeCount: number;
  open: boolean;
}

const FilterTriggerButton = React.forwardRef<HTMLButtonElement, FilterTriggerButtonProps>(
  ({ label, activeCount, open, ...props }, ref) => (
    <Button ref={ref} variant={ButtonVariant.OUTLINE} {...props}>
      <FilterIcon className="size-4" />
      {label}
      {activeCount > 0 && <Badge size="sm">{activeCount}</Badge>}
      <CollapsibleChevron open={open} />
    </Button>
  )
);
FilterTriggerButton.displayName = 'FilterTriggerButton';

export { FilterTriggerButton };
export type { FilterTriggerButtonProps };
